
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Bestpginhinjewadiphaseforworkimg() {



    const cardData =
    {
        keyword: 'Best PG in Hinjewadi Phase 3 for Working Ladies ',
        heading: 'Shree Swami Samarth PG: Best PG in Hinjewadi Phase 3 for Working Ladies ',
        headingDescription: 'Shree Swami Samarth PG provides the best PG in Hinjewadi Phase 3 for working ladies, offering a secure, comfortable, and homely environment close to major IT offices and business hubs. Perfectly suited for women professionals, our PG ensures safety with 24x7 CCTV surveillance, secure access, and disciplined management. The rooms are spacious, fully furnished, and thoughtfully designed with comfortable bedding, study/work areas, and ample storage to create a stress-free living experience. Residents are served nutritious home-cooked meals along with access to modern amenities like high-speed WiFi, 24x7 water supply, and regular housekeeping, making everyday living convenient. Located in a prime area of Hinjewadi Phase 3 with easy connectivity to IT companies, public transport, and daily essentials, Shree Swami Samarth PG is the trusted choice for working ladies seeking a reliable, budget-friendly, and well-managed accommodation in Pune.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Fully Furnished Women's Rooms",
    "description": "PGs in Hinjewadi Phase 3 for working ladies offer fully furnished rooms equipped with comfy beds, storage space, study tables, and ergonomic chairs. Options include single and twin sharing to suit both privacy and affordability needs. Interiors are clean, well-lit, and ventilated—crafted for comfort after long workdays. Some properties even offer AC-equipped rooms to enhance relaxation. Such thoughtful setups create a calm, homely environment ideal for female professionals."
  },
  {
    "title": "Meals Provided with Hygiene",
    "description": "An added advantage of these PGs is the daily provision of nutritious meals—breakfast, lunch, and dinner—often prepared in hygienic kitchen environments. Food inclusions help save time after busy shifts and ensure healthy, home-style eating. Dietary preferences, such as vegetarian meals, are typically accommodated. With food covered, residents can focus on their careers without daily cooking or outside food worries."
  },
  {
    "title": "Fast Wi-Fi and Work-Friendly Spaces",
    "description": "PGs here include robust high-speed Wi-Fi throughout the property to support remote working, virtual meetings, and research. Many also offer common work or study areas furnished with carts, lighting, and charging points for a focused environment. Coupled with reliable power backup, these spaces ensure productivity without interruptions—perfect for women balancing IT work and personal time."
  },
  {
    "title": "Women-Only Secure Premises",
    "description": "Safety is paramount, with amenities such as CCTV surveillance, secure gated entry, and regulated visitor policies available in many ladies-only PGs. Located in peaceful, residential parts of Phase 3, the PGs offer controlled access and staff presence for added protection. This provides peace of mind to families and empowers residents to feel safe even during late hours."
  },
  {
    "title": "Prime Location Near Infosys and IT Parks",
    "description": "These PGs are strategically located around Hinjewadi Phase 3, placing them near Infosys, Tech Mahindra, and other IT hubs—minimizing commute times. Convenience extends to nearby amenities like convenience stores, cafes, and gyms. The neighborhood is well-connected via cab services and public transport, enhancing daily life and supporting a balanced work–life routine."
  },
  {
    "title": "Daily Housekeeping & Laundry Support",
    "description": "Professional housekeeping services keep rooms and bathrooms clean and tidy every day, including sanitation and garbage disposal. Laundry options—either in-house or outsourced—are typically available, saving residents valuable time. These conveniences allow working women to maintain a balanced lifestyle with minimal chores, enhancing comfort and wellness."
  },
  {
    "title": "Community Lounge & Recreational Facilities",
    "description": "Beyond bedrooms, many PGs provide shared lounge areas, TVs, or small recreation zones where women can unwind and socialize. Some properties host informal get-togethers, fostering a sense of community among working professionals. These communal spaces help reduce feelings of isolation, encouraging peer bonding after work hours."
  },
  {
    "title": "Transparent & Value-Based Pricing",
    "description": "PGs in Phase 3 offer clear and competitive pricing—twin-sharing rooms typically start around ₹6,000–₹8,000/month, while premium single rooms can range from ₹8,500–₹12,000/month. These packages generally include meals, Wi-Fi, housekeeping, and security, offering excellent value. Transparent billing ensures that working professionals can budget effectively without hidden charges."
  }
],


"services": [
  {
    "name": "Best PG for Working Ladies in Hinjewadi Phase 3",
    "description": "Shree Swami Samarth PG offers the best PG experience for working ladies in Hinjewadi Phase 3. With thoughtfully designed interiors, nutritious meals, reliable housekeeping, and complete security, our PG provides a peaceful and supportive environment just minutes from major tech offices."
  },
  {
    "name": "Ladies PG in Phase 3 Hinjewadi",
    "description": "Our Ladies PG in Phase 3 Hinjewadi is perfect for female professionals and interns working in nearby IT parks. Shree Swami Samarth PG features fully furnished rooms, 24/7 security, and a friendly atmosphere, ensuring a home-like stay for all women tenants."
  },
  {
    "name": "Working Women PG in Phase 3",
    "description": "Specifically designed for working women, this PG in Hinjewadi Phase 3 combines comfort, safety, and convenience. Shree Swami Samarth PG offers AC and non-AC rooms, fast Wi-Fi, nutritious meals, and a calm environment to unwind after long workdays."
  },
  {
    "name": "PG with Food for Ladies in Phase 3",
    "description": "Enjoy tasty, hygienic, and home-style meals at our Ladies PG with food in Phase 3, Hinjewadi. Shree Swami Samarth PG includes both veg and non-veg meal options served daily, with flexible meal timings to suit the schedules of busy working professionals."
  },
  {
    "name": "Secure PG for Women in Hinjewadi Phase 3",
    "description": "Safety comes first at Shree Swami Samarth PG for women in Hinjewadi Phase 3. With round-the-clock CCTV, biometric access, and female staff support, our PG ensures that working women live in a secure, well-managed, and peaceful environment close to their offices."
  },
  {
    "name": "PG for IT Professionals in Phase 3",
    "description": "Shree Swami Samarth PG caters to IT professionals working in Phase 3 Hinjewadi with premium amenities like high-speed internet, ergonomic work desks, clean surroundings, and full meal service. It’s an ideal living space for software engineers, analysts, and interns alike."
  },
  {
    "name": "Female PG Near TCS Phase 3 Hinjewadi",
    "description": "Just a few minutes away from the TCS campus in Phase 3, our Female PG is designed for convenience, comfort, and commute ease. Shree Swami Samarth PG offers quick access to your office along with safe housing, food, Wi-Fi, and daily support services."
  },
  {
    "name": "Affordable PG for Working Women in Phase 3",
    "description": "Looking for budget-friendly yet quality living? Shree Swami Samarth PG offers affordable PG options for working women in Phase 3, Hinjewadi. With shared and single occupancy options, meals, Wi-Fi, and security included, it’s ideal for young professionals on the go."
  },
  {
    "name": "Luxury PG for Ladies in Hinjewadi Phase 3",
    "description": "For those who want to live with style and comfort, our Luxury PG for Ladies in Hinjewadi Phase 3 features AC rooms, elegant interiors, attached bathrooms, smart TVs, and chef-prepared meals. Shree Swami Samarth PG delivers a hotel-like experience for female professionals."
  }
],
"tableData": [
  ["Best PG for Working Ladies in Hinjewadi Phase 3", "Ladies PG in Phase 3 Hinjewadi"],
  ["Working Women PG in Phase 3", "PG with Food for Ladies in Phase 3"],
  ["Secure PG for Women in Hinjewadi Phase 3", "PG for IT Professionals in Phase 3"],
  ["Female PG Near TCS Phase 3 Hinjewadi", "Affordable PG for Working Women in Phase 3"],
  ["Luxury PG for Ladies in Hinjewadi Phase 3", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Top PG for Working Women in Hinjewadi Phase 3",
        "WhyChoosedescription": "Shree Swami Samarth PG offers a well-managed, female-only paying guest accommodation in Hinjewadi Phase 3, ideal for working ladies seeking a safe, peaceful, and well-connected place to live. With high-end facilities, freshly prepared meals, and 24/7 support, we ensure a home-like stay close to your workplace."
    },
    {
        "WhyChooseheading": "Walking Distance from Major IT Companies in Phase 3",
        "WhyChoosedescription": "Conveniently located near top tech parks and IT companies in Hinjewadi Phase 3—including Infosys, Wipro, Tech Mahindra, and TCS—our PG allows you to skip long commutes and enjoy a better work-life balance with easy access to your office."
    },
    {
        "WhyChooseheading": "Safe, Secure, and Female-Only PG",
        "WhyChoosedescription": "Your safety is our priority. Our PG is exclusively for women, with biometric entry, 24/7 CCTV surveillance, in-house wardens, and restricted visitor access. Parents can rest easy knowing you're living in a secure and professionally managed space."
    },
    {
        "WhyChooseheading": "Comfortable, Fully Furnished Rooms",
        "WhyChoosedescription": "Choose from single, twin, or triple-sharing AC rooms—all furnished with beds, wardrobes, work desks, high-speed Wi-Fi, and clean attached bathrooms. The peaceful ambiance is perfect for relaxing after work or staying productive during WFH days."
    },
    {
        "WhyChooseheading": "Nutritious Meals and Clean Dining Area",
        "WhyChoosedescription": "We serve fresh, healthy meals three times a day, prepared in a hygienic kitchen. Both vegetarian and non-vegetarian options are available, with weekend special menus and flexible timings to suit different work shifts."
    },
    {
        "WhyChooseheading": "All-Inclusive Packages – No Extra Charges",
        "WhyChoosedescription": "Our monthly rent includes meals, Wi-Fi, laundry, housekeeping, and electricity. No brokerage or hidden costs. You get flexible payment terms and the convenience of one simple bill each month—ideal for working professionals."
    },
    {
        "WhyChooseheading": "Clean, Quiet, and Professional Living Environment",
        "WhyChoosedescription": "Live with other like-minded working women in a respectful and tidy environment. We maintain strict hygiene protocols, noise control policies, and well-kept common areas—creating a peaceful space to relax and recharge."
    },
    {
        "WhyChooseheading": "24/7 Assistance and Maintenance Support",
        "WhyChoosedescription": "Whether it’s a maintenance request, food issue, or emergency, our staff is available round-the-clock. From Wi-Fi repairs to health emergencies, we ensure everything runs smoothly—so you can focus on your work without worry."
    }
]






















    }

const faqData = [
    {
        question: "How can I book the best PG in Hinjewadi Phase 3 for working ladies?",
        answer: "You can book your stay by calling us at +91 9594917913. We also assist with online booking and virtual property tours."
    },
    {
        question: "Is your PG in Hinjewadi Phase 3 exclusively for working ladies?",
        answer: "Yes, we offer dedicated PG accommodation for working ladies with a secure, peaceful, and professional environment."
    },
    {
        question: "What amenities are available at your PG for working women in Hinjewadi Phase 3?",
        answer: "We provide fully furnished rooms, high-speed Wi-Fi, A/C, attached bathrooms, daily housekeeping, laundry, power backup, and 24/7 security with female wardens."
    },
    {
        question: "Do you provide food at your PG for ladies in Hinjewadi Phase 3?",
        answer: "Yes, we offer freshly cooked, hygienic vegetarian meals three times a day—breakfast, lunch, and dinner."
    },
    {
        question: "How close is your PG to major companies in Hinjewadi Phase 3?",
        answer: "Our PG is just minutes away from major companies like Tech Mahindra, TCS, Infosys, and Cognizant, making daily commutes quick and easy."
    },
    {
        question: "Is the PG safe for single working women?",
        answer: "Absolutely. We maintain 24/7 CCTV surveillance, female staff, restricted access, and strict visitor policies for complete safety and peace of mind."
    },
    {
        question: "What types of rooms are available for working ladies?",
        answer: "We offer single, double, and triple sharing rooms with modern amenities. A/C and attached bathroom options are also available."
    },
    {
        question: "What is the monthly rent at your PG in Hinjewadi Phase 3 for ladies?",
        answer: "Rent varies depending on room type and amenities. Contact us directly for the latest prices and best offers."
    },
    {
        question: "Is there a minimum stay requirement for booking?",
        answer: "Yes, the minimum stay is generally one month. Longer stays are welcome with flexible terms and better pricing."
    },
    {
        question: "How do I contact Shree Swami Samarth PG to book a PG for working ladies in Hinjewadi Phase 3?",
        answer: "You can call us at +91 9594917913 to inquire, schedule a visit, or book your room directly."
    }
];

const testimonialsData = [
    {
        name: 'Ms. Prachi Deshmukh',
        designation: 'Project Manager, Tech Mahindra Hinjewadi Phase 3',
        rating: [1, 1, 1, 1, 1],
        text: '“The best PG for working women in Phase 3. Everything is well-maintained and safe. It’s close to my office and meals are homely.”',
    },
    {
        name: 'Ms. Manasi Patil',
        designation: 'QA Engineer, TCS Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommended for working ladies. Clean rooms, great food, and a secure environment. I’ve extended my stay twice!”',
    },
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best PG in Hinjewadi Phase 3 for Working Ladies",
  "image": "https://swamisamarthpg.com/assets/images/best-pg-hinjewadi-phase3-working-ladies.jpg", // Replace with actual image URL
  "description": "Secure and affordable PG accommodations for working ladies in Hinjewadi Phase 3 with food facilities. Ideal for IT professionals and female working women near TCS and other offices.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9700",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/best-pg-hinjewadi-phase3-working-ladies"  // Replace with actual page URL if different
  }
};




    return (
        <div>
<Helmet>
  <title>Best PG in Hinjewadi Phase 3 for Working Ladies | Secure & Affordable PG</title>
  <meta 
    name="description" 
    content="Secure and affordable PG for working ladies in Hinjewadi Phase 3 with food facilities. Perfect for IT professionals and female working women near TCS and office hubs." 
  />
  <meta 
    name="keywords" 
    content="Best PG for Working Ladies in Hinjewadi Phase 3, Ladies PG in Phase 3 Hinjewadi, Working Women PG in Phase 3, PG with Food for Ladies in Phase 3, Secure PG for Women in Hinjewadi Phase 3, PG for IT Professionals in Phase 3, Female PG Near TCS Phase 3 Hinjewadi, Affordable PG for Working Women in Phase 3, Luxury PG for Ladies in Hinjewadi Phase 3" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bestpginhinjewadiphaseforworkimg;